import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.string.fixed";
import staticQueryData from "../../../../public/static/d/2774637065.json";
import React from 'react';
import Helmet from 'react-helmet';
export default function SEO(_ref) {
  var title = _ref.title;
  var data = staticQueryData.data;
  var metaDescription = data.site.siteMetadata.description;
  var metaTitle = title || data.site.siteMetadata.title;
  var url = data.site.siteMetadata.siteUrl;
  var image = url + data.socialImage.childImageSharp.fixed.src;
  return React.createElement(Helmet, {
    htmlAttributes: {
      lang: 'en'
    },
    title: metaTitle,
    meta: [{
      name: 'description',
      content: metaDescription
    }, {
      property: 'og:title',
      content: metaTitle
    }, {
      property: 'og:url',
      content: url
    }, {
      property: 'og:description',
      content: metaDescription
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: image
    }, {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:image:src',
      content: image
    }, {
      name: 'twitter:creator',
      content: data.site.siteMetadata.author
    }, {
      name: 'twitter:title',
      content: metaTitle
    }, {
      name: 'twitter:description',
      content: metaDescription
    }]
  });
}